import React, { useState } from "react";
import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14, className = "" }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={size} strokeWidth={1.5} className={i <= Math.round(value) ? "fill-gold text-gold" : "fill-none text-forest/25"} />
    ))}
  </span>
);

export const StarInput = ({ value = 0, onChange, size = 28 }) => {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex gap-1.5" data-testid="review-rating-input" onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button type="button" key={i} data-testid={`review-star-${i}`} aria-label={`${i} star`} onMouseEnter={() => setHover(i)} onClick={() => onChange(i)} className="transition-transform hover:scale-110">
          <Star size={size} strokeWidth={1.5} className={i <= (hover || value) ? "fill-gold text-gold" : "fill-none text-forest/30"} />
        </button>
      ))}
    </div>
  );
};
